import React from 'react';



const css = {
  height: '85vh'
};
export default function Loader() {
  return (
    <main>
      <section className="app-sticky-header-wrapper"></section>
      <section className="main app-body">
        <div className="app-spacing">
          <div className="app-body-content">
            <div style={css} className="app-body-center row bg-white shadow-sm p-4">
              <h2>Please wait while your page is loading...</h2>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
